export default "__VITE_ASSET__BdZCgNdl__"